import api from "./api.js"
import $store from '../store/index.js'
import axios from 'axios'
import $router from '../router'
import { message } from 'ant-design-vue';

export default function() {
//拦截器
		axios.interceptors.request.use(
			config => {
        config.headers.channel = sessionStorage['channel']
        config.headers.yuyan = window.localStorage.guanwanglang
        if(!config.data){
          config.data = {lan:window.localStorage.guanwanglang}
        }
				// config.headers.token = window.localStorage.token
				return config
			}, err => {
				console.log(err)
			})
  //响应拦截器
  axios.interceptors.response.use(
    response => {
      if (response.data.code) {
        if (response.data.code == 3000) {
          message.warning(response.data.qmismsg)
          // location.href = '/qmisgroup'
          // 部署正式
          // location.href='https://www.qmisgroup.com/'
          location.href ='http://202.130.113.149/qmisgroup'
          // $router.push({
          //   path: '/'
          // })
        }
      }
      return response
    }, error => {
      message.warning(error.data.qmismsg)
      return Promise.reject(error) //接口返回的错误信息
    })
}



// WEBPACK FOOTER //
// ./src/assets/axiosConfig.js